/**
 * Dates
 */
import 'moment';
import 'moment-timezone';
import 'flatpickr';
/**
 * jQuery
 */
import 'jquery';
import 'jquery-validation';
import 'jquery-toast-plugin';
/**
 * Bootstrap
 */
import 'popper.js';
import 'bootstrap';
import 'bootstrap-tokenfield';
import 'bootstrap-colorpicker';
import 'bootstrap-validator';

import 'typeahead.js';
import 'hummingbird-treeview';
import 'chosen-js';
import 'sortablejs';
import 'codemirror';

import './scss/app';

import Modal from './components/modal';
import Editor from './components/editor';
import Initials from './components/initials';
import Selector from './components/selector';
import Cards from './components/cards';
import TimeZone from './components/timezone';
import ImageOverlay from './components/image-overlay';
import GroupPermissions from './components/permissions/group-permissions';
import Permissions from './components/permissions/permissions';
import Button from './components/button';
import Datatable from './components/datatable';
import Boxer from './components/boxer';
import API from './components/api';
import Carousel from './components/carousel';
import Delete from './components/cloud/delete';
import Banner from './components/banner';
import ScrollTo from './components/scroll-to';
import Chosen from './components/chosen/chosen';
import Popover from './components/popover';
import RolePicker from './components/role-picker';
import EmailTester from './components/email-tester';
import FormValidation from './components/form/form-validation';
import Form from './components/form/form';
import FormSpecsEditor from './components/form/formspecs-editor';
import ColorPicker from './components/form/color-picker';
import Catalog from './components/catalog/catalog';
import CatalogPlan from './components/catalog/catalog-plan';
import Recurly from './components/recurly';
import LogScreen from './components/log-screen';
import Toggle from './components/toggle';
import Cart from './components/cart';
import MagicPicker from './components/magic-picker';
import UserTokenizer from './components/user-tokenizer';
import Site from './components/site/site';
import DragAndDrop from './components/drag-and-drop';
import CatalogVersion from './components/catalog/catalog-version';
import CatalogItemTable from './components/catalog/catalog-item-table';
import CatalogVersionCompatibility from './components/catalog/catalog-version-compatible-product';
import ItemStatus from './components/item-status';
import Retry from './components/cloud/retry';
import LoadImage from './components/load-image';
import Page from './components/page/page';
import DateFormat from './components/utils/date-format';
import UpdateSite from './components/site/update';
import CatalogPlanAddOn from './components/catalog/catalog-plan-addon';
import MenuMobile from './components/menu-mobile';
import FlashMessages from './components/flash-messages';
import Globals from './components/utils/globals';
import CustomizeTheme from './components/site/customize-theme';
import ApiTokensTable from './components/api-tokens/api-tokens-table';
import ReadyPlayerAvatar from './components/ready-player-avatar';
import ServiceSSO from './components/services/sso';
import Typeahead from './components/typeahead';
import Store from './components/store/store';
import Nav from './components/store/nav';
import CDNOrigin from './components/cdn/cdn-origin';
import FormGroupKeyValue from './components/form/form-group-key-value';
import FormGroupCollection from './components/form/form-group-collection';
import CDNBehavior from './components/cdn/cdn-behavior';
import CDNGeographicRestrictions from './components/cdn/cdn-geographic-restrictions';
import CDNUpdate from './components/cdn/cdn-update';
import CatalogsSearch from './components/catalog/catalogs-search';
import TokenToggle from './components/token-toggle';
import EntityHeader from './components/entity-header';
import Utils from './components/utils/utils';
import Category from './components/catalog/category';
import AddProvider from './components/provider/add-provider';
import SubscriptionsSearch from './components/search/subscriptions-search';
import PurchasesSearch from './components/search/purchases-selector';
import CustomerIO from './components/customer-io';

// Lazy Load
import(
    /* webpackChunkName: "extras" */
    /* webpackMode: "lazy" */
    /* webpackExports: ["default", "named"] */
    'slick-carousel'
);

// Register solodev namespace.
window.solodev = {};
new Globals();

function ready(fn) {
    if (document.readyState != 'loading'){
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

ready(function() {
    new FormValidation(true);
    new Modal();
    new Selector();
    new Initials();
    new Cards();
    new TimeZone();
    new EmailTester();
    new ImageOverlay();
    new GroupPermissions();
    new Permissions();
    new Button();
    new Datatable();
    new Boxer();
    new API();
    new Carousel();
    new Delete();
    new Banner();
    new ScrollTo();
    new Chosen(true);
    new Popover();
    new Form();
    new FormSpecsEditor();
    new Catalog();
    new Recurly();
    new LogScreen();
    new RolePicker();
    new Toggle();
    new Cart();
    new MagicPicker();
    new CatalogPlan();
    new Category();
    new UserTokenizer();
    new Site();
    new DragAndDrop();
    new CatalogVersion();
    new Editor();
    new CatalogItemTable();
    new CatalogVersionCompatibility();
    new ItemStatus();
    new Retry();
    new LoadImage();
    new Page();
    new DateFormat();
    new UpdateSite();
    new CatalogPlanAddOn();
    new FlashMessages();
    new MenuMobile();
    new CustomizeTheme();
    new ApiTokensTable();
    new ReadyPlayerAvatar();
    new ServiceSSO();
    new Typeahead();
    new CDNOrigin();
    new FormGroupKeyValue();
    new FormGroupCollection();
    new CDNBehavior();
    new Store();
    new Nav();
    new CDNGeographicRestrictions();
    new CDNUpdate();
    new CatalogsSearch();
    new ColorPicker();
    new TokenToggle();
    new EntityHeader();
    new Utils();
    new AddProvider();
    new SubscriptionsSearch();
    new PurchasesSearch();
    new CustomerIO();
})
